export default "__VITE_ASSET__BAG93j2p__"